// extracted by css-extract-rspack-plugin
export default {"mobileTileContainer":"_3a158eea","shimmer":"_d05c37c","shimmerLoadingBackground":"_3a82d414"};